import { Country, Language, Location } from '../types/location';

export const composeLocationRequest = (location: Location): Location => {
  const requestLocation = {
    ...location,
    DefaultLanguage:
      location.DefaultLanguage === Language.Japanese
        ? 'ja'
        : location.DefaultLanguage.toLowerCase(),
    BusinessNumber: location.BusinessNumber?.replace(/\s/g, ''),
    PostalCode:
      location.Country === Country['United Kingdom'] ||
      location.Country === Country['Canada']
        ? location.PostalCode.replace(/\s/g, '')
        : location.PostalCode,
  } as Location;

  delete (requestLocation as Location & { EnableSepa?: boolean }).EnableSepa;

  if (!requestLocation.BankDebitMethod) {
    delete requestLocation.BankDebitMethod;
    delete requestLocation.DirectDebitPercentageFee;
    delete requestLocation.DirectDebitFlatFee;
  } else {
    if (requestLocation.DirectDebitPercentageFee == null) {
      delete requestLocation.DirectDebitPercentageFee;
    }
    if (requestLocation.DirectDebitFlatFee == null) {
      delete requestLocation.DirectDebitFlatFee;
    }
  }

  return requestLocation;
};
